import {
    creativeActions,
    creativeThunks as defaultThunks,
    creativeSelectors as defaultSelectors,
    creativeReducer,
} from './Creative-slice';
import * as thunks from './Creative-thunks';
import * as selectors from './Creative-selectors';

const creativeThunks = { ...defaultThunks, ...thunks };
const creativeSelectors = { ...defaultSelectors, ...selectors };

export { creativeSelectors, creativeActions, creativeThunks, creativeReducer };
